import React, { useState, useEffect } from 'react';
import { getApiUrl } from '../config/apiConfig';
import { useAuth } from '../contexts/AuthContext';
import { useCaja } from '../contexts/CajaContext';
import './AperturaCajaModal.css';
import './AsignacionCajerosModal.css';

const AsignacionCajerosModal = ({ onClose }) => {
  const { auth } = useAuth();
  const { cajasAbiertas } = useCaja();

  const [cajeros, setCajeros] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [guardando, setGuardando] = useState({}); // { [idUsuario]: true/false }
  const [mensajeExito, setMensajeExito] = useState('');

  useEffect(() => {
    const fetchCajeros = async () => {
      try {
        const response = await fetch(getApiUrl('/caja/cajeros'), {
          headers: { 'Authorization': `Bearer ${auth.token}` }
        });
        if (!response.ok) {
          const errData = await response.json();
          throw new Error(errData.message || 'Error al cargar cajeros.');
        }
        const data = await response.json();
        setCajeros(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchCajeros();
  }, [auth.token]);

  const handleAsignarCaja = async (idUsuario, idCaja) => {
    setGuardando(prev => ({ ...prev, [idUsuario]: true }));
    setMensajeExito('');
    try {
      const response = await fetch(getApiUrl(`/caja/cajeros/${idUsuario}`), {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth.token}`
        },
        body: JSON.stringify({ id_caja: idCaja || null })
      });
      if (!response.ok) {
        const errData = await response.json();
        throw new Error(errData.message || 'Error al guardar asignación.');
      }
      // Actualizar el estado local del cajero
      setCajeros(prev => prev.map(c => {
        if (c.id !== idUsuario) return c;
        const cajaSeleccionada = cajasAbiertas.find(cj => cj.id === idCaja);
        return {
          ...c,
          id_caja_asignada: idCaja || null,
          nombre_caja: cajaSeleccionada ? cajaSeleccionada.nombre : null,
        };
      }));
      setMensajeExito('Asignación guardada.');
      setTimeout(() => setMensajeExito(''), 2000);
    } catch (err) {
      setError(err.message);
    } finally {
      setGuardando(prev => ({ ...prev, [idUsuario]: false }));
    }
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-content modal-content-asignacion">
        <h2>Asignación de Cajeros a Cajas</h2>

        {cajasAbiertas.length === 0 && (
          <div className="asignacion-aviso">
            No hay cajas abiertas en este momento. Abre al menos una caja antes de asignar cajeros.
          </div>
        )}

        {loading && <div className="loading-text">Cargando cajeros...</div>}
        {error && <div className="error-message">{error}</div>}
        {mensajeExito && <div className="asignacion-exito">{mensajeExito}</div>}

        {!loading && !error && cajeros.length === 0 && (
          <div className="asignacion-aviso">No hay usuarios con rol CAJERO registrados.</div>
        )}

        {!loading && cajeros.length > 0 && (
          <table className="asignacion-tabla">
            <thead>
              <tr>
                <th>Cajero</th>
                <th>Caja Asignada</th>
              </tr>
            </thead>
            <tbody>
              {cajeros.map(cajero => (
                <tr key={cajero.id}>
                  <td className="asignacion-nombre">
                    <div className="asignacion-nombre-completo">
                      {cajero.nombre} {cajero.apellido}
                    </div>
                    <div className="asignacion-usuario">@{cajero.usuario}</div>
                  </td>
                  <td>
                    <select
                      value={cajero.id_caja_asignada || ''}
                      onChange={(e) => {
                        const val = e.target.value;
                        handleAsignarCaja(cajero.id, val ? parseInt(val) : null);
                      }}
                      disabled={guardando[cajero.id]}
                      className="asignacion-select"
                    >
                      <option value="">— Sin asignar —</option>
                      {cajasAbiertas.map(caja => (
                        <option key={caja.id} value={caja.id}>
                          {caja.nombre}
                        </option>
                      ))}
                    </select>
                    {guardando[cajero.id] && (
                      <span className="asignacion-guardando">Guardando...</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        <div className="modal-actions" style={{ marginTop: '1.5rem' }}>
          <button className="btn-primary" onClick={() => onClose()}>Cerrar</button>
        </div>
      </div>
    </div>
  );
};

export default AsignacionCajerosModal;
